import { useEffect, useRef, useState } from 'react';

/**
 * Gera o PDF ao montar a pré-visualização e segura blob + object URL.
 * `gerarBlob` continua a cargo de quem conhece o documento (receita, atestado, requisição).
 */
export function useGerarPDF(gerarBlob) {
  const [blob, setBlob] = useState(null);
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const urlRef = useRef(null);

  useEffect(() => {
    if (!gerarBlob) return undefined;

    let ativo = true;
    setLoading(true);

    (async () => {
      try {
        const nextBlob = await gerarBlob();
        if (!ativo) return;

        const nextUrl = URL.createObjectURL(nextBlob);
        if (urlRef.current) URL.revokeObjectURL(urlRef.current);
        urlRef.current = nextUrl;
        setBlob(nextBlob);
        setUrl(nextUrl);
      } catch {
        // sem URL a tela mostra erroGeracao
      } finally {
        if (ativo) setLoading(false);
      }
    })();

    return () => {
      ativo = false;
    };
  }, [gerarBlob]);

  useEffect(() => {
    return () => {
      if (urlRef.current) {
        URL.revokeObjectURL(urlRef.current);
        urlRef.current = null;
      }
    };
  }, []);

  return { blob, url, loading };
}
